import ModalForm from 'components/commons/modal-form'
import RadioButton from 'components/commons/radio-button'
import { Badge, Switch } from 'avo-ui'

export const FormAccessibility = ({ show, onHide, dataRole, dataAccessibility, isLoading, onChangeForm, onSubmit }) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-[500px] overflow-auto'}
            show={show}
            onHide={onHide}
            title={'Edit Access'}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Role</div>
                    <div className={'flex flex-col space-y-3 max-h-52 overflow-auto'}>
                        {dataRole.map((item, index) => (
                            <div
                                key={index}
                                className={`flex justify-between items-center p-3 border rounded-md cursor-pointer ${dataAccessibility?.name === item?.label && 'bg-blue-5'}`}
                                onClick={() => onChangeForm({ name: 'role', value: item })}
                            >
                                <p>{item?.label}</p>
                                <RadioButton
                                    name={item?.value}
                                    value={item?.value}
                                    checked={dataAccessibility?.name === item?.label}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'flex justify-between items-center'}>
                        <div className={'font-semibold text-blue-90 required'}>Status</div>
                        <Switch
                            name={'status'}
                            checked={dataAccessibility?.status === 'active'}
                            onChange={onChangeForm}
                        />
                    </div>
                    <Badge title={dataAccessibility?.status} type={dataAccessibility?.status} />
                </div>
            </div>
        </ModalForm>
    )
}
